import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import { updateTournament } from "../../redux/slices/tournamentSlice";
import ClubbieButton from "../ClubbieButton/ClubbieButton";
import ClubbieInput from "../ClubbieInput/ClubbieInput";
import ClubbieModal from "../Modal/ClubbieModal";

/**
 * UpdateTournamentNoOfPitches - JSX component with Tailwind CSS
 * Modal for updating number of pitches in tournament venue
 * 
 * Features:
 * - Number input with validation (positive integers only)
 * - Updates tournament.matchVenue.numberOfPitches field
 * - Real-time input validation
 * - Toast notifications
 * 
 * @param {boolean} isOpen - Modal visibility state
 * @param {function} onClose - Callback to close modal
 */
const UpdateTournamentNoOfPitches = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );

  const [isLoading, setIsLoading] = useState(false);

  const [numberOfPitches, setNumberOfPitches] = useState(
    selectedTournament?.matchVenue?.numberOfPitches?.toString() || ""
  );

  const handleNumberOfPitchesChange = (e) => {
    setNumberOfPitches(e.target.value);
  };

  const handleUpdateNoOfPitches = async () => {
    try {
      setIsLoading(true);
      const { pitches, ...updateData } = {
        matchVenue: {
          ...selectedTournament?.matchVenue,
          numberOfPitches: Number(numberOfPitches),
        },
      };
      delete updateData.matchVenue.pitches;
      const result = await dispatch(
        updateTournament({
          id: selectedTournament?.id,
          updateData,
        })
      ).unwrap();

      if (result) {
        toast.success("Number of pitches updated successfully!");
        onClose();
      }
    } catch (error) {
      toast.error(error.message || "Failed to update number of pitches");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ClubbieModal
      isOpen={isOpen}
      toggle={onClose}
      title="Update Number of Pitches"
    >
      <div className="flex flex-col gap-4 p-6">
        <ClubbieInput
          type="number"
          placeholder="Edit Number of Pitches"
          value={numberOfPitches}
          onChange={handleNumberOfPitchesChange}
          min="1"
          className="w-full"
        />

        <ClubbieButton
          className="w-full"
          onClick={handleUpdateNoOfPitches}
          disabled={isLoading || !numberOfPitches}
          isLoading={isLoading}
        >
          Update
        </ClubbieButton>
      </div>
    </ClubbieModal>
  );
};

export default UpdateTournamentNoOfPitches;
